import React, { useMemo, useState } from 'react'
import { RegisterV1 } from './RegisterV1';
import { RegisterV2 } from './RegisterV2';


export const RegisterPage: React.FC = () => {
    const [guardVersion] = useState(window.__guardVersion__);

    const registerRender = useMemo(() => {
        switch (guardVersion) {
            case 'v1':
                return <RegisterV1 />
            case 'v2':
                return <RegisterV2 />
            default:
                return <RegisterV1 />
        }
    }, [guardVersion])

    return registerRender
}
